import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

import de from './de.json';

export const defaultNS = 'en';

i18next.use(initReactI18next).init({
    lng: 'en', // if you're using a language detector, do not define the lng option
    debug: true,
    resources: {
        en: {
            en,
            de,
        },
    },
    defaultNS,
});
